import React, { useState, useCallback } from 'react';
import axiosInstance from '../config/axios';
import './SupportModal.css';

const SUBJECT_OPTIONS = [
  { value: 'Get in Contact', label: 'Get in Contact' },
  { value: 'Suggestions & Improvements', label: 'Suggestions & Improvements' },
  { value: 'Report a Problem', label: 'Report a Problem' },
];

const SupportModal = ({ open, onClose, tenantName }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const resetForm = useCallback(() => {
    setName('');
    setEmail('');
    setSubject('');
    setMessage('');
    setError('');
    setSuccess(false);
  }, []);

  const handleClose = useCallback(() => {
    if (!submitting) {
      resetForm();
      onClose?.();
    }
  }, [onClose, resetForm, submitting]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const msg = (message || '').trim();
    if (msg.length < 20) {
      setError('Message must be at least 20 characters.');
      return;
    }
    setSubmitting(true);
    try {
      await axiosInstance.post('/api/public/support', {
        name: name.trim(),
        email: email.trim(),
        subject: subject || SUBJECT_OPTIONS[0].value,
        message: msg,
        tenantName: tenantName || undefined,
      });
      setSuccess(true);
      setTimeout(() => {
        handleClose();
      }, 2000);
    } catch (err) {
      const msg = err.response?.data?.error || err.response?.data?.message || 'Failed to send. Please try again or email us directly.';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) return null;

  return (
    <div className="support-modal-overlay" onClick={handleClose} role="dialog" aria-modal="true" aria-labelledby="support-modal-title">
      <div className="support-modal" onClick={(e) => e.stopPropagation()}>
        <div className="support-modal-header">
          <h2 id="support-modal-title" className="support-modal-title">Support</h2>
          <button type="button" className="support-modal-close" onClick={handleClose} aria-label="Close">&times;</button>
        </div>
        {success ? (
          <p className="support-modal-success">
            Thank you for contacting SimplyInventory. We'll get back to you.
          </p>
        ) : (
          <form className="support-modal-form" onSubmit={handleSubmit}>
            {tenantName != null && tenantName !== '' && (
              <div className="support-modal-form-group">
                <label htmlFor="support-tenant">Tenant</label>
                <input id="support-tenant" type="text" value={tenantName} readOnly className="support-modal-input" />
              </div>
            )}
            <div className="support-modal-form-group">
              <label htmlFor="support-name">Name</label>
              <input id="support-name" type="text" value={name} onChange={(e) => setName(e.target.value)} required className="support-modal-input" />
            </div>
            <div className="support-modal-form-group">
              <label htmlFor="support-email">Email</label>
              <input id="support-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="support-modal-input" />
            </div>
            <div className="support-modal-form-group">
              <label htmlFor="support-subject">Subject</label>
              <select id="support-subject" value={subject} onChange={(e) => setSubject(e.target.value)} required className="support-modal-input">
                {SUBJECT_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
            <div className="support-modal-form-group">
              <label htmlFor="support-message">Message (min 20 characters)</label>
              <textarea id="support-message" value={message} onChange={(e) => setMessage(e.target.value)} required minLength={20} rows={4} className="support-modal-input" />
            </div>
            {error && <div className="support-modal-error">{error}</div>}
            <div className="support-modal-actions">
              <button type="button" className="btn btn-secondary" onClick={handleClose} disabled={submitting}>Cancel</button>
              <button type="submit" className="btn btn-primary" disabled={submitting}>{submitting ? 'Sending…' : 'Send'}</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default SupportModal;
